import React from "react";

// Import from bootstrap
import { Navbar, Container, Nav, Button, Dropdown } from "react-bootstrap";

const NavbarComp = () => {
  return (
    <>
      <Navbar variant="dark" expand="lg" className="navbar" fixed="top">
        <Container>
          <Navbar.Brand href="/">
            <img alt="valorant-logo" src="../assets/img/logo.webp" width="30" height="30" className="d-inline-block align-top me-2" />
            <strong>Info Valo</strong>
          </Navbar.Brand>
          <Navbar.Toggle />
          <Navbar.Collapse className="justify-content-end">
            <Nav>
              <Nav.Link href="/">Inicio</Nav.Link>
              <Nav.Link href="/agents">Agentes</Nav.Link>
              <Nav.Link href="/mapas">Mapas</Nav.Link>
              <Nav.Link href="/roles">Roles</Nav.Link>
              <Dropdown as={Nav.Item}>
                <Dropdown.Toggle as={Nav.Link} id="weapons-dropdown">
                  Armas
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item href="/armas">Por categoria</Dropdown.Item>
                  <Dropdown.Item href="/skins">Por Apariencia</Dropdown.Item>
                  <Dropdown.Item href="/skinsPacks">Packs de Skins</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <Nav.Link href="/modos">Modos de juego</Nav.Link>
              {/* <Nav.Link href="/skinsPacks">Packs de Skins</Nav.Link> */}
              <Nav.Link href="/sprays">Sprays</Nav.Link>              
              <Nav.Link href="/about">Acerca</Nav.Link>
              <Button class="button" className="nav-button ms-2" size="sm"  id="but_install" aria-label="Install" hidden>
                <strong >Instalar APP</strong>
              </Button>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default NavbarComp;
